module.exports = __webpack_public_path__ + "stu-res/img/e-01@3x.dd9d0f71.png";